<!--
 * @Description: 
 * @Author: luckymiaow
 * @Date: 2022-05-24 17:43:51
 * @LastEditors: luckymiaow
-->

<script setup lang="ts">
import type { SelectValue } from 'ant-design-vue/lib/select';
import { computed, ref, useAttrs, watchEffect } from 'vue';
import { LoadingOutlined } from '@ant-design/icons-vue';
import { Select } from '../../select';
import type { IStandardSelectProps, StandardModel } from '../types';
import useStandard from './useStandard';

interface Props extends IStandardSelectProps {
  allApi?(): Promise<StandardModel[]>;
  byKeyApi?({ key }: { key: string }): Promise<StandardModel>;
  sKey: string; // 标准key
  labelInValue?: boolean;
  showArrow?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  showArrow: true,
});

const emit = defineEmits(['update:value']);

function update(...ags: any[]) {
  emit('update:value', ...ags);
}

const attrs = useAttrs();

const { getBindValue, standard, standardChange, loading } = useStandard<IStandardSelectProps>({ attrs, props });

const placeholder = computed(() => getBindValue.value?.placeholder ?? standard.value?.name ?? '请选择');

const options = computed(() => {
  const o = standard.value?.standardItems ?? [];

  return o;
});

const value = ref<SelectValue>(getBindValue.value.value ?? defaultValue(options.value));

watchEffect(() => {
  value.value = getBindValue.value.value;
});

standardChange(() => {
  value.value = getBindValue.value.value || defaultValue(options.value);
  update(value.value);
});

function defaultValue(options: any[]) {
  const data = options.filter(e => e.isDefault);
  let result;
  if (data.length > 0) {
    if (['multiple', 'tags'].includes(getBindValue.value.mode || '')) {
      if (getBindValue.value.labelInValue)
        result = data.map(e => {
          return { value: e.value, label: e.label };
        });
      else result = data.map(e => e.value);
    } else if (getBindValue.value.labelInValue) result = { label: data[0].label, value: data[0].value };
    else result = data[0].value;
  }
  return result;
}
</script>

<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>

<template>
  <Select
    v-bind="getBindValue"
    v-model:value="value"
    :options="options"
    :replace-files="{ value: 'value', label: 'label' }"
    :placeholder="placeholder"
    @update:value="update"
  >
    <template v-for="item in Object.keys($slots)" #[item]="data">
      <slot :name="item" v-bind="data || {}"></slot>
    </template>
    <template v-if="loading" #suffixIcon> <LoadingOutlined spin /> </template
  ></Select>
</template>
